import React from 'react';
import { RotationCargoOperationVM } from 'src/utils/stowage/stowageOperation/operationFormatUtils';
import { OperationsTableHeader, OperationsTableHeaderCell, OperationsTableSectionHeader } from './OperationsForCargoPanel.styles';

export const TableHeader: React.FC = () => {
    return (
        <OperationsTableHeader>
            <OperationsTableHeaderCell>#</OperationsTableHeaderCell>
            <OperationsTableHeaderCell>Port</OperationsTableHeaderCell>
            <OperationsTableHeaderCell>Nom. Weight</OperationsTableHeaderCell>
            <OperationsTableHeaderCell>BL Weight</OperationsTableHeaderCell>
            <OperationsTableHeaderCell>Ship Figure</OperationsTableHeaderCell>
            <OperationsTableHeaderCell>Stowed Weight</OperationsTableHeaderCell>
            <OperationsTableHeaderCell>Not Stowed Weight</OperationsTableHeaderCell>
        </OperationsTableHeader>
    );
};

interface SectionHeaderProps {
    operation: RotationCargoOperationVM;
    prevOperation: RotationCargoOperationVM | null;
}

export const LoadingHeader: React.FC<SectionHeaderProps> = ({ operation, prevOperation }) => {
    const shouldShow = operation.operationType === 'Loading' && (!prevOperation || prevOperation.operationType !== 'Loading');

    if (!shouldShow) return null;

    return <OperationsTableSectionHeader>Loading Operations</OperationsTableSectionHeader>;
};

export const UnloadingHeader: React.FC<SectionHeaderProps> = ({ operation, prevOperation }) => {
    const shouldShow = operation.operationType === 'Unloading' && (!prevOperation || prevOperation.operationType !== 'Unloading');

    if (!shouldShow) return null;

    return <OperationsTableSectionHeader>Unloading Operations</OperationsTableSectionHeader>;
};

export const TransitHeader: React.FC<SectionHeaderProps> = ({ operation, prevOperation }) => {
    const shouldShow = operation.operationType === 'Transit' && (!prevOperation || prevOperation.operationType !== 'Transit');

    if (!shouldShow) return null;

    return <OperationsTableSectionHeader>In Transit</OperationsTableSectionHeader>;
};
